<template>
  <div class="payCardMain" :class="{ isLoading: isLoading }">
    <div class="primer_main">
      <div class="paypal_btn" id="paypalBtn" v-show="isSportPaypal"></div>
      <div class="paypal_btn" id="paylaterBtn" v-show="isSportPaylater"></div>
    </div>
  </div>
</template>

<script>
import { loadScript } from '@paypal/paypal-js'
import { getpaypalorder, paypal_callback } from '@/api/index.js'
import { encryptData } from '@/api/crypto'
import { mapState } from 'vuex'
import { getCallPaymentLimitTrackingProps } from '@/tool/packagePurchaseLimit'
import mixinCheckTaxExpires from '@/mixins/mixinCheckTaxExpires.js'
export default {
  name: 'paypal',
  mixins: [mixinCheckTaxExpires],
  inject: ['newCheckPay'],
  props: ['payinfo', 'pay_btn_style', 'paypalBtns'],
  computed: {
    ...mapState({
      gameId: (state) => state.app.gameId,
      userInfo: (state) => state.user.userInfo,
      loginType: (state) => state.user.loginType,
      userIpCountry: (state) => state.user.userIpCountry,
      isProductionTax: (state) => state.app.isProductionTax,
      paypal_client_id: (state) => state.config.gameConfig.paypal_client_id,
    }),
  },
  data() {
    return {
      payis: true,
      cg_request_id: '',
      provider_order_id: '',
      approve_url: '',
      client_key: '',
      baseurl: process.env.VUE_APP_API_BASEURL,
      cardSubmitDisabled: true,
      //判断是否加载过
      payinitis: false,
      //是否是黑名单
      checkPayis: false,

      conf: {
        0: {
          type: 'PAYPAL',
          dom: '#paypalBtn',
          key: 'isSportPaypal',
        },
        1001: {
          type: 'PAYLATER',
          dom: '#paylaterBtn',
          key: 'isSportPaylater',
        },
      },
      isLoading: true,
      isSportPaypal: false,
      isSportPaylater: false,
    }
  },
  watch: {
    pay_btn_style() {
      this.initPaypal()
    },
  },
  created() {
    this.initPaypal()
  },
  mounted() {
    this.$store.commit('app/SET_IS_NO_SCROLL', true)
  },
  beforeDestroy() {
    this.$store.commit('app/SET_IS_NO_SCROLL', false)
  },
  methods: {
    async initPaypal() {
      if (this.pay_btn_style !== 'paypal') return
      if (this.payinitis) return

      this.payinitis = true
      this.$parent.payment_log.report('web_payment_sdkinit_start')
      await this.loadPaypalSdk()
      if (!window.paypal) return
      if (this.paypalBtns.length > 0) {
        this.paypalBtns.forEach((res) => {
          this.renderPayBtn(res)
        })
      }
      this.payis = false
    },
    async loadPaypalSdk() {
      try {
        const params = {
          'client-id': this.paypal_client_id,
          currency: this.payinfo.currency,
          'disable-funding': 'card,bancontact',
          'enable-funding': 'paylater',
        }

        if (process.env.NODE_ENV !== 'production') {
          params['buyer-country'] = this.userIpCountry
        }

        await loadScript(params)
      } catch (error) {
        console.error('failed to load the PayPal JS SDK script', error)
        this.$parent.payment_log.report('web_payment_sdkinit_fail', {
          code: 2,
          msg: error,
        })
        this.$rum.errorReport(error)
      }
    },
    // 普通支付
    renderPayBtn(type) {
      console.log('renderPayBtn========', type)
      const vm = this
      const btn = paypal.Buttons({
        fundingSource: paypal.FUNDING[this.conf[type].type],
        style: {
          disableMaxWidth: true,
          disableMaxHeight: true,
          color: 'gold',
        },
        createOrder: () => this.createOrder(type),
        onApprove: this.onApprove,
        onCancel: this.onCancel,
        onError: this.onError,
        onInit: function () {
          console.log('paypal ok')
          vm.$parent.payment_log.report('web_payment_sdkinit_success')
        },
      })
      this.$rum.report('start_render_paypal', {
        gateway: this.conf[type].type,
        is_eligible: btn.isEligible(),
        user_ip_country: this.userIpCountry,
      })
      if (btn.isEligible()) {
        this[this.conf[type].key] = true
        this.isLoading = false
        btn.render(this.conf[type].dom).catch(() => (this[this.conf[type].key] = false))
      }
    },
    // 创建订单
    createOrder(type) {
      if (!this.mixinCheckTaxExpires()) {
        return false
      }

      this.$rum.report('start_create_paypal_order', {
        gateway: this.conf[type].type,
        type: type,
        user_ip_country: this.userIpCountry,
      })
      this.$parent.payment_log.report('web_payment_getorder_start')
      const params = {
        ...this.payinfo,
        user_id: this.userInfo.user_id,
        enter_type: this.loginType,
        bonus: this.$store.state.user.isFirst ? 1 : 0,
        gateway: type,
        taxed: this.isProductionTax,
      }

      return getpaypalorder(params)
        .then((res) => {
          //校验黑名单之类的
          this.checkPayis = this.newCheckPay(res)
          if (!this.checkPayis) {
            return false
          }

          const data = res.data

          if (data.code !== 1) {
            console.log('paypal order create failed', data)
            this.$parent.failpay('Order failed！')

            this.$parent.payment_log.report('web_payment_getorder_fail', {
              code: 3,
              msg: data.msg ? data.msg : 'Order failed',
            })

            this.$rum.report(
              'pay_err',
              {
                paystyle: 'paypal',
                gateway: this.conf[type].type,
                type: 'createOrder',
                response: data,
                prams: JSON.stringify(encryptData(this.payinfo)),
              },
              3
            )
            return
          }
          return data.data
        })
        .then((orderData) => {
          if (!orderData) return

          //打点时机
          const taData = {
            iap_product_id: this.payinfo.product_id,
            payment_type: 'paypal',
            operator_type: 2,
            amount:
              this.isProductionTax && this.payinfo.taxed_price
                ? this.payinfo.taxed_price
                : this.payinfo.amount,
            currency: this.payinfo.currency,
            server_id: this.payinfo.user_extra_value,
            tid: orderData.provider_order_id,
            use_type: '',
            is_full: type == 0 ? true : false,
            ...getCallPaymentLimitTrackingProps(this.$parent.pack),
            ...(this.$store.state.app.fromInstalledWebApp
              ? { open_ui_old: 'desktop_shortcut' }
              : {}),
          }
          if (this.gameId === '20195') {
            taData.iap_name = this.payinfo.data_name || ''
            taData.pkg_id = this.payinfo.pack_id || ''
            taData.reward = this.payinfo.reward || ''
          }
          this.$ta.track('call_payment', taData)

          this.cg_request_id = orderData.cg_request_id + ''
          this.provider_order_id = orderData.provider_order_id
          this.$utils.customSessionStorage.setItem('provider_order_id', orderData.provider_order_id)
          this.$parent.updateProviderOrderId(orderData.provider_order_id)
          this.$parent.payment_log.set_properties({
            cg_request_id: this.provider_order_id + '',
          })
          this.$parent.payment_log.report('web_payment_getorder_success')
          this.$parent.payment_log.report('web_payment_userpay_start')

          this.$rum.report(
            'pay_success',
            {
              paystyle: 'paypal',
              gateway: this.conf[type].type,
              type: 'createOrder',
              response: orderData,
              prams: JSON.stringify(encryptData(this.payinfo)),
            },
            1
          )
          return orderData.order_id
        })
        .catch((error) => {
          this.$parent.failpay('Order failed！')
          this.$rum.errorReport(error)

          console.log('error-0---')
          console.log(error)

          this.$parent.payment_log.report('web_payment_getorder_error', {
            code: 2,
            msg: error.message || error,
          })
        })
    },
    // 支付成功
    onApprove(data, actions) {
      const vm = this
      var obj = {
        provider_order_id: vm.provider_order_id,
      }
      vm.$parent.payment_log.report('web_payment_userpay_success')
      vm.$parent.payment_log.report('web_payment_verification_start')

      return paypal_callback(obj)
        .then((res) => {
          const data = res.data
          var orderData = data.data
          vm.payis = false

          if (data.code == 1) {
            vm.$parent.successpay(orderData)

            vm.$parent.payment_log.set_properties({
              transaction_id: orderData.transaction_id ? orderData.transaction_id : '',
            })
            vm.$parent.payment_log.report('web_payment_check_success')

            vm.$rum.report(
              'pay_success',
              {
                paystyle: 'paypal',
                type: 'onApprove',
                response: data,
                prams: JSON.stringify(encryptData(obj)),
              },
              1
            )
          } else {
            var errorDetail = Array.isArray(orderData.error_details) && orderData.error_details[0]
            if (errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED') {
              return actions.restart()
            } else {
              let langKey = ''
              let uuid = ''
              if (data.code == 101031025) {
                langKey = 'pay.limitPackBuyFail'
                uuid = obj.provider_order_id
              } else {
                langKey = data.fail_code
                uuid = data.uuid
              }
              vm.$parent.failpay({
                ...data,
                data: {
                  ...(data.data || {}),
                  fail_code: langKey,
                  uuid: uuid,
                },
              })
            }

            vm.$parent.payment_log.report('web_payment_check_fail', {
              code: 3,
              msg: data.msg ? data.msg : '',
            })

            vm.$rum.report(
              'pay_err',
              {
                paystyle: 'paypal',
                type: 'onApprove',
                response: data,
                prams: JSON.stringify(encryptData(obj)),
              },
              3
            )
          }
          return
        })
        .catch((error) => {
          console.error('capture failed', error)
          vm.payis = false

          vm.$parent.failpay('Payment failure')
          vm.$parent.payment_log.report('web_payment_check_error', {
            code: 2,
            msg: error.message || error,
          })
          vm.$rum.errorReport(error)
          return
        })
    },
    // 错误处理
    onError(err) {
      if (this.checkPayis == false) {
        return false
      }

      console.log('onError', err)
      this.payis = false
      this.$parent.failpay('Payment failure')
      if (this.provider_order_id == '') {
        this.$parent.payment_log.report('web_payment_sdkinit_fail', {
          code: 2,
          msg: err,
        })
      } else {
        this.$parent.payment_log.report('web_payment_userpay_fail', {
          code: 2,
          msg: err,
        })
      }

      this.$rum.errorReport(err)
      //throw Error(error);
    },
    // 取消支付回调
    onCancel(data) {
      this.payis = false
      this.$parent.payment_log.report('web_payment_userpay_cancel')
    },
  },
}
</script>

<style scoped lang="less">
.payCardMain {
  width: 100%;
  height: 40px;
  position: relative;
  &.isLoading {
    background-color: #ffc439;
    &::before {
      content: '';
      position: absolute;
      top: calc(50% - 10px);
      left: calc(50% - 10px);
      width: 20px;
      height: 20px;
      .bg-image('icon_loading');
      animation: rotate 1s linear infinite;
    }
  }
}
.primer_main {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  .paypal_btn {
    flex: 1;
    height: 100%;
    border-radius: 20px;
    overflow: hidden;
  }
}

@media (min-width: 1024px) {
  .payCardMain {
    height: unset;
    min-height: 40px;
    .primer_main {
      display: block;
      .paypal_btn {
        flex-shrink: 0;
        width: 100%;
        height: 40px;
        overflow: hidden !important;
        & + .paypal_btn {
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
